import { format } from "date-fns"
import * as locale from "date-fns/locale"
import type { LocaleCode } from "../types/common"
import type { WeekStartsOn } from "../types/dates"

export function localeFormat(
  date: Date,
  formatString: string,
  localeCode: LocaleCode,
  weekStartsOn: WeekStartsOn = 1,
) {
  return format(date, formatString, {
    locale: locale[localeCode],
    weekStartsOn,
  })
}
